import { All, KeyValue, SortDirection } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import FinancialReportingLevelOne from "../components/FinancialReporting/FinancialReportingLevelOne";
import { updateSortOrder, updateUi } from "../common/actions";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
    institutionType: (appState as KeyValue)[appState.app].ui.institutionType,
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateSort: (sortField: string, sortDirection: SortDirection) => {
      dispatch(updateSortOrder(sortField, sortDirection));
    },
    clearLatestReportPeriod: () => {
      dispatch(updateUi("latestReportPeriod", undefined));
    },
    updateUi: (uiField: string, uiValue: string[] | undefined) => {
      dispatch(updateUi(uiField, uiValue));
    },
    removeFilters: (filterValues: string[]) => {
      filterValues.forEach(filter =>
        dispatch(actions.updateFilter(filter, "")),
      );
    },
    removeSearch: (searchValues: string[]) => {
      searchValues.forEach(search =>
        dispatch(actions.updateSearch(search, "")),
      );
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FinancialReportingLevelOne);
